<template>
    <span class="icon-width">
        <font-awesome-icon v-if="this.icons" :icon="this.icons" />
    </span>
</template>

<script>
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    export default {
        name: 'SidebarMenuIcon',
        components:{
            FontAwesomeIcon
        },
        props: {
            icons: {
                type: [String, Object],
                default: ''
            }
        }
    }
</script>
